import React from 'react';
import s from '../../../styles/Form.module.scss'
import '../../../styles/buttons.scss'


export const EmailReset = ({
  loading,
  email,
  setEmail,
  handleResetRequest,
  resetPasswordFlow,
}) => {
  return (
    <>
      <form onSubmit={handleResetRequest} className={s.form}>
        <h3 className={s.title}>
          Password reset
        </h3>
        <p className={s.subtitle}>We'll email you a verification code to reset your password.</p>
        <label
          htmlFor="email"
          className={s.label}
        >
          Email
        </label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="example@google.com"
          className={s.input}
          required
        />
        <div className='btn-wrap'>
          <button
            type="submit"
            disabled={loading}
            className={`btn btn-primary ${loading ? 'loading' : ''}`}
          >
            {loading ? 'Sending code…' : 'Send reset code'}
          </button>
          <button
            type="button"
            onClick={resetPasswordFlow}
            disabled={loading}
            className={`btn btn-orange ${loading ? 'loading' : ''}`}
          >
            Back to sign in
          </button>

        </div>
      </form>
    </>
  )
};
